import { useState, useEffect } from 'react';
import { listPrompts } from '../../../../services';
import { useStore } from '../../../../hooks' 


export const useExistingPromptNames = () => {
  const [existingNames, setExistingNames] = useState([]);
  const { authStore } = useStore();
  const tenantId = authStore.selectedAccount.id;

  useEffect(() => {
    const fetchNames = async () => {
      try {
        const response = await listPrompts({ 
          tenantId, 
          page: 1, 
          pageSize: 10000 
        });
        
        if (response.data && Array.isArray(response.data)) {
          const names = response.data.map(prompt => prompt.name);
          setExistingNames(names);
        }
      } catch (err) {
        console.error('Error fetching prompt names:', err);
        setExistingNames([]);
      }
    };

    if (tenantId) {
      fetchNames();
    }
  }, [tenantId]);

  return existingNames;
}; 